import reactUpdate from 'immutability-helper';

import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';

import {MenuActionType} from './MenuReduxActions';

export interface MenuState {
  hoverIndex: number;
  /** array of optionDataIndices that are selectable */
  selectableIndices: Array<number>;
  /** for testing only */
  openAllSubmenus?: boolean;
}

export interface MenusUIState {
  menusByCid: {[menuCid: string]: MenuState};
}

export class MenuStateSelector {
  menusState: MenusUIState;

  constructor(state: BenchlingState) {
    this.menusState = state.ui.menus;
  }

  getMenuState(cid: string): MenuState {
    const menuState = this.menusState.menusByCid[cid];
    if (!menuState) {
      return {
        hoverIndex: 0,
        selectableIndices: [],
      };
    }
    return menuState;
  }
}

export default function reduceMenusUI(
  state: MenusUIState = {
    menusByCid: {},
  },
  action: BenchlingAction
): MenusUIState {
  switch (action.type) {
    case MenuActionType.MENU_CHANGE_HOVER_INDEX: {
      const {cid, hoverIndex} = action;
      return reactUpdate(state, {menusByCid: {[cid]: {$merge: {hoverIndex}}}});
    }
    case MenuActionType.MENU_SELECTABLE_INDICES_UPDATED: {
      const {cid, hoverIndex, selectableIndices} = action;
      return reactUpdate(state, {menusByCid: {[cid]: {$set: {hoverIndex, selectableIndices}}}});
    }
    case MenuActionType.TEST_ONLY_SET_OPEN_ALL_SUBMENUS: {
      const {cid, openAllSubmenus} = action;
      return reactUpdate(state, {menusByCid: {[cid]: {$merge: {openAllSubmenus}}}});
    }
    default:
      return state;
  }
}
